import { ApolloClient, DefaultOptions } from '@apollo/client/core';
import { createPersistedQueryLink } from '@apollo/client/link/persisted-queries';
import { sha256 } from 'crypto-hash';
import { createUploadLink } from 'apollo-upload-client';
import { ApolloCache } from '@apollo/client/cache';
import { NormalizedCacheObject } from '@apollo/client/cache/inmemory/types';


const defaultOptions: DefaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },
}

export function createClient(uri: string, cache: ApolloCache<NormalizedCacheObject>): ApolloClient<any> {
  const link = createPersistedQueryLink({ sha256, useGETForHashedQueries: true })
    .concat(createUploadLink({ uri, headers: { 'Apollo-Require-Preflight': 'enabled' }}));
  return new ApolloClient<any>({
    link,
    connectToDevTools: true,
    cache,
    defaultOptions,
  })
}
